import $ from 'jquery'

window.jQuery = window.$ = $

const headers = {
  'Key-Inflection': 'camel',
  'Content-Type': 'application/json'
}

const tokenTag = document.querySelector('meta[name="csrf-token"]')

if (tokenTag) {
  headers['X-CSRF-Token'] = tokenTag.attributes.content.value
} else {
  process.env.RAILS_ENV !== 'production' && console.warn('jquery No CSRF content tag!')
}

$.ajaxSetup({ headers, contentType: 'application/json' })

export default $
